// hooks/useFeatureSwitches.ts
import { Dispatch, SetStateAction, useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import { useDetailsStore } from "@/stores/useDetailsStore";

import { FEATURE_NAMES } from "../../../../../shared/featureToggles/types";

const useFeatureSwitches = () => {
  const { t } = useTranslation();

  // Global persistent Recoil state
  const [isIntegrationsPageEnabled, setIsIntegrationsPageEnabled] =
    useState(false);

  const setResetDetailsOnPageChange = useDetailsStore(
    (state) => state.setResetDetailsSection
  );

  // Dialog-local temporary state
  const [stagedFeatureState, setStagedFeatureState] = useState<
    Partial<Record<FEATURE_NAMES, boolean>>
  >({
    [FEATURE_NAMES.ShowIntegrationsPage]: isIntegrationsPageEnabled
  });

  const handleFeatureToggle = useCallback((featureName: FEATURE_NAMES) => {
    setStagedFeatureState((prev) => ({
      ...prev,
      [featureName]: !prev[featureName]
    }));
  }, []);

  const resetToStoredValues = useCallback(() => {
    setStagedFeatureState({
      [FEATURE_NAMES.ShowIntegrationsPage]: isIntegrationsPageEnabled
    });
  }, [isIntegrationsPageEnabled]);

  const featuresList = [
    {
      name: t("Dialog##feature switches##toggle integrations page"),
      isChecked: stagedFeatureState[FEATURE_NAMES.ShowIntegrationsPage],
      onToggle: () => handleFeatureToggle(FEATURE_NAMES.ShowIntegrationsPage)
    }
  ];

  const handleFeatureSwitches = (
    setIsApplyLoading: Dispatch<SetStateAction<boolean>>,
    onCloseDialog: () => void
  ) => {
    const updatedValue = stagedFeatureState[FEATURE_NAMES.ShowIntegrationsPage];

    setIsApplyLoading(true);

    setTimeout(() => {
      setIsIntegrationsPageEnabled(updatedValue ?? false);
      setResetDetailsOnPageChange(false);

      onCloseDialog();
      setIsApplyLoading(false);
    }, 500);
  };

  return { featuresList, handleFeatureSwitches, resetToStoredValues };
};

export default useFeatureSwitches;
